import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Bill from './seat/Bill';
import HowPayDialog from './seat/HowPayDialog';
import { fetchDefault } from './Utils.js';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';

const monthList = [
    {
        value: 1,
        label: '4주(28일)',
    },
    {
        value: 2,
        label: '8주(56일)',
    },
    {
        value: 3,
        label: '12주(84일)',
    },
    {
        value: 4,
        label: '16주(112일)',
    },
    {
        value: 5,
        label: '20주(140일)',
    },
    {
        value: 6,
        label: '24주(168일)',
    },
    {
        value: 7,
        label: '28주(196일)',
    },
    {
        value: 8,
        label: '32주(224일)',
    },
    {
        value: 9,
        label: '36주(252일)',
    },
    {
        value: 10,
        label: '40주(280일)',
    },
    {
        value: 11,
        label: '44주(308일)',
    },
    {
        value: 12,
        label: '48주(336일)',
    },
    {
        value: 13,
        label: '52주(364일)',
    }
];

const useStyles = makeStyles(theme => ({
    paper: {
        width: '100%',
        marginTop: 1,
        overflowX: 'auto',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 280,
    },
}));

export default function CabinetUse() {
    const classes = useStyles();

    const [month, setMonth] = React.useState();
    const [cabinet, setCabinet] = React.useState();
    const [cabinetList, setCabinetList] = React.useState([]);


    const [originalPrice, setOriginalPricet] = React.useState();
    const [memberDiscount, setMemberDiscount] = React.useState();
    const [usePoint, setUsePoint] = React.useState();
    const [myPoint, setMyPoint] = React.useState();
    const [totalPrice, setTotalPrice] = React.useState();


    const [isSelected, setIsSelected] = React.useState(false);
    const onMonthChange = event => {
        if (!isSelected) {

            setMonth(event.target.value);

            //테이블 리스트
            fetchDefault('/Cabinet/GetAvailableCabinetList?month=' + event.target.value,
                (data) => {
                    setCabinetList([data][0]);
                    //setCabinet([data][0][0].id);
                }
            );

            setBill(event.target.value, cabinet);

            setTimeout(function () { setIsSelected(false); }, 1000);
        }
        setIsSelected(true);
    };


    const [isSelected2, setIsSelected2] = React.useState(false);
    const onCabinetChanged = event => {
        if (!isSelected2) {

            setCabinet(event.target.value);
            //계산
            setBill(month, event.target.value);

            setTimeout(function () { setIsSelected2(false); }, 1000);
        }
        setIsSelected2(true);
    };


    useEffect(() => {

        //테이블 리스트
        /*
        fetchDefault('/Cabinet/GetAvailableCabinetList?month=2',
            (data) => {
                setCabinetList([data][0]);
                if ([data][0][0].id) {
                    setCabinet([data][0][0].id);

                    //계산
                    setBill(month, [data][0][0].id);
                }
            }
        );
        */

        return () => {
        }
    }, []);

    const setBill = (month, cabinetId) => {
        fetchDefault('/Cabinet/GetCabinetBill?cabinetId=' + cabinetId + '&month=' + month,
            (data) => {
                setOriginalPricet(data.originalPrice);
                setMemberDiscount(data.memberDiscount);
                setUsePoint(data.usePoint);
                setTotalPrice(data.totalPrice);
                setMyPoint(data.myPoint);
            }
        );

    }


    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>사물함 이용하기</h2>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 기간을 선택해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="기간"
                        className={classes.textField}
                        value={month}
                        onChange={onMonthChange}
                        SelectProps={{
                            MenuProps: {
                                className: classes.menu,
                            },
                        }}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccessTimeIcon />
                                </InputAdornment>
                            ),
                        }}
                    >
                        {monthList.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        2. 이용을 원하시는 사물함번호를 선택해주세요.
                    </Typography>

                    <Typography variant="body2">
                        (카페를 둘러보시고, 사물함번호를 확인하세요.)
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="사물함"
                        className={classes.textField}
                        value={cabinet}
                        onChange={onCabinetChanged}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <WorkOutlineIcon />
                                </InputAdornment>
                            ),
                        }}
                        SelectProps={{
                            MenuProps: {
                                className: classes.menu,
                            },
                        }}
                        margin="normal"
                        variant="outlined"
                    >
                        {cabinetList.map(option => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.number}번
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        3. 결제를 진행해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Bill originalPrice={originalPrice} memberDiscount={memberDiscount} usePoint={usePoint} myPoint={myPoint}  totalPrice={totalPrice} />
                </Grid>

                <Grid item xs={12}>
                    <HowPayDialog usePoint={usePoint} totalPrice={totalPrice} controllerUrl={'/Cabinet/PayCabinet?startDateTime=&cabinetId=' + cabinet + '&month=' + month} />
                </Grid>
            </Grid>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/CabinetUse.js